module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_chugoku-shikoku_sp_77c4f3d37c499d9986bd593f3dd19322.png";